import { z } from "zod"

export const WebhookResponseDataSchema = z.object({
  success: z.boolean(),
  status: z.number(),
  error: z.string().optional(),
  data: z.string().optional(),
})
